import { MaterialDefinitionType } from 'commons-app/types/material-definition.type';

export const RESULT_TYPES = ['QUANTITATIVE', 'QUALITATIVE'] as const;

export type ResultType = (typeof RESULT_TYPES)[number];

export const isResultType = (value: string): value is ResultType => (RESULT_TYPES as readonly string[]).includes(value);

export const RANGE_MODES = ['MIN_MAX', 'TARGET_DEVIATION'] as const;

export type RangeMode = (typeof RANGE_MODES)[number];

export const isRangeMode = (value: string): value is RangeMode => (RANGE_MODES as readonly string[]).includes(value);

export interface DeviceTypeSummary {
    id: string;
    name: string;
}

export interface TestSummary {
    id: string;
    name: string;
}

export interface QcLevel {
    ordinal?: number;
    name: string;
    defaultMin?: number;
    defaultMax?: number;
    defaultTarget?: number;
    defaultDeviationPercent?: number;
    defaultTargetValues?: string;
}

export interface TestConfig {
    testId: string;
    testName: string;
    resultType: ResultType;
    rangeMode?: RangeMode | null;
    qcLevels?: QcLevel[];
    possibleValues?: string;
}

export interface LotValidationRules {
    maxLength: number;
    allowAlphanumeric: boolean;
}

export interface MaterialDefinition {
    id: string;
    name: string;
    longName: string;
    provider: string;
    type: MaterialDefinitionType;
    deviceType: DeviceTypeSummary;
    testConfigs: TestConfig[];
    lotValidationRules: LotValidationRules;
    hasLots: boolean;
}
